import PropTypes from 'prop-types';

const floodlightPageLoadEventPropTypes = PropTypes.shape({
  activityGroupTagString: PropTypes.string,
  activityTagString: PropTypes.string,
  countingMethod: PropTypes.string,
});

export { floodlightPageLoadEventPropTypes };
